var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSideNavDescription(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 16.0357H11.75V14.5357H4.25V16.0357ZM4.25 12.0357H11.75V10.5357H4.25V12.0357ZM2.3 19.7857C1.8 19.7857 1.375 19.6107 1.025 19.2607C0.675 18.9107 0.5 18.4857 0.5 17.9857V2.58571C0.5 2.08571 0.675 1.66071 1.025 1.31071C1.375 0.960706 1.8 0.785706 2.3 0.785706H10.25L15.5 6.03571V17.9857C15.5 18.4857 15.325 18.9107 14.975 19.2607C14.625 19.6107 14.2 19.7857 13.7 19.7857H2.3ZM9.5 6.78571V2.28571H2.3C2.23333 2.28571 2.16667 2.31904 2.1 2.38571C2.03333 2.45237 2 2.51904 2 2.58571V17.9857C2 18.0524 2.03333 18.119 2.1 18.1857C2.16667 18.2524 2.23333 18.2857 2.3 18.2857H13.7C13.7667 18.2857 13.8333 18.2524 13.9 18.1857C13.9667 18.119 14 18.0524 14 17.9857V6.78571H9.5Z",
    fill: "#6E7079"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideNavDescription);
export default __webpack_public_path__ + "static/media/SideNavDescription.e5e1f7434467dcc6eb8941943a6e23ef.svg";
export { ForwardRef as ReactComponent };